import { useI18n } from '@popety_io/popety-io-lib'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid'
import Box from '@mui/material/Box'
import LocalFireDepartmentIcon from '@mui/icons-material/LocalFireDepartment'
import SolarPowerIcon from '@mui/icons-material/SolarPower'

const EstimateEnergyHeader = ({ data }: { data: any }) => {
  const { t } = useI18n()

  const totalPower =
    data?.totalPower ||
    data?.instalationDate
      ?.map((d: any) => d?.power)
      ?.reduce((a: any, b: any) => a + b, 0) ||
    data?.solar_installed_power

  return (
    <>
      <Box
        position="sticky"
        top={0}
        pt={2}
        zIndex={10}
        bgcolor="background.paper"
      >
        <Typography
          variant="h2"
          sx={{
            marginBottom: '4px',
            textTransform: 'uppercase',
          }}
          fontSize="1.7rem"
          fontWeight={500}
        >
          {t('common.search.details.energy')}
        </Typography>
        <Typography
          variant="body1"
          sx={{
            color: '#969696',
            paddingBottom: '10px',
          }}
          fontSize="1rem"
        >
          {t('common.energy.header_description')}
        </Typography>
      </Box>
      <Box>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={6}>
            <Grid container spacing={2}>
              <Grid item xs={2}>
                <LocalFireDepartmentIcon
                  fontSize="large"
                  sx={{
                    color: (theme) => theme.palette.primary.main,
                  }}
                />
              </Grid>
              <Grid item xs={10}>
                <Box>
                  <Typography
                    variant="h3"
                    fontSize="2.5rem"
                    sx={{
                      color: (theme) => theme.palette.primary.main,
                    }}
                    fontWeight={600}
                  >
                    {data?.power_source_heater
                      ? t(`common.${data?.power_source_heater}`)
                      : '-'}
                  </Typography>
                  <Typography
                    fontSize="1rem"
                    sx={{
                      color: '#969696',
                    }}
                    fontWeight={500}
                  >
                    {t("common.Source d'énergie chauffage")}
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <Grid container spacing={2}>
              <Grid item xs={2}>
                <SolarPowerIcon
                  fontSize="large"
                  sx={{
                    color: (theme) => theme.palette.primary.main,
                  }}
                />
              </Grid>
              <Grid item xs={10}>
                <Box>
                  <Typography
                    variant="h3"
                    fontSize="2.5rem"
                    sx={{
                      color: (theme) => theme.palette.primary.main,
                    }}
                    fontWeight={600}
                  >
                    {totalPower ? `${totalPower} kW` : '-'}
                  </Typography>
                  <Typography
                    fontSize="1rem"
                    sx={{
                      color: '#969696',
                    }}
                    fontWeight={500}
                  >
                    {t('common.Installation solaire actuelle')}
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </>
  )
}

export default EstimateEnergyHeader
